import type { AxiosRequestConfig } from 'axios';
import type {
  TagCreateResponse,
  TagListResponse,
  TagRequest,
  TagResponse,
  TagUpdateRequest,
} from '@/entities/srm/tag';
import { srmInstance } from '@/shared/api/api-instances/srm/api-instance';

class TagsApi {
  getTagsList(options: AxiosRequestConfig = {}) {
    return srmInstance.get<TagListResponse[]>(`/tags`, options);
  }

  getTagById(tag_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.get<TagResponse>(`/tag/${tag_id}`, options);
  }

  createTag(tag: TagRequest, options: AxiosRequestConfig = {}) {
    return srmInstance.post<TagCreateResponse>(`/tag`, tag, options);
  }

  updateTag(
    tag: TagUpdateRequest,
    tag_id: string,
    options: AxiosRequestConfig = {},
  ) {
    return srmInstance.post<TagCreateResponse>(`/tag/${tag_id}`, options);
  }

  deleteTag(tag_id: string, options: AxiosRequestConfig = {}) {
    return srmInstance.post(`/tag/${tag_id}`, options);
  }
}

export const tagsApi = new TagsApi();